import { colors } from '@sweep-io/sweep-design';
import { HORIZONTAL_PADDING } from '../configuration-canvas-panel/consts';

export const PANEL_SEARCH_BACKGROUND_COLOR = colors.grey[100];
export const PANEL_SEARCH_PADDING = `8px ${HORIZONTAL_PADDING}px`;
export const PANEL_EXPANDED_SEARCH_BORDER_RADIUS = '8px';

export const globalSearchSx = (isExpandedMode: boolean) => {
  const sidePadding = PANEL_SEARCH_PADDING;

  return {
    background: PANEL_SEARCH_BACKGROUND_COLOR,
    p: sidePadding,
    borderRadius: isExpandedMode ? PANEL_EXPANDED_SEARCH_BORDER_RADIUS : 0,
  };
};
